import { render, staticRenderFns } from "./dutyquestiondetails.vue?vue&type=template&id=159620f8&scoped=true&"
import script from "./dutyquestiondetails.vue?vue&type=script&lang=js&"
export * from "./dutyquestiondetails.vue?vue&type=script&lang=js&"
import style0 from "./dutyquestiondetails.vue?vue&type=style&index=0&id=159620f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159620f8",
  null
  
)

export default component.exports